export default __webpack_public_path__ + "static/media/movie_theater.996b1ad8.jpeg";